import type { z } from 'zod';
import { parseZodError } from './apiErrorLogger';

export const validateSchema =
  <T, S extends z.ZodType<T>>(schema: S) =>
  (params: z.input<S>): z.output<S> => {
    const parsedResult = schema.safeParse(params);

    if (!parsedResult.success) {
      const parsedErrors = parsedResult.error ? parseZodError(parsedResult.error) : [];
      throw new Error(`API validation failed: ${parsedErrors.join(', ')}`);
    }

    return parsedResult.data;
  };
